import { getVariants, variants, fontFamily } from "./fonts";
import colors from "./colors";

export { colors, getVariants, variants, fontFamily };
